import React from 'react';
import { PercentileBand } from '../../services/yieldService';

interface LegendBarProps {
  percentileBands: PercentileBand[];
}

export const LegendBar: React.FC<LegendBarProps> = ({ percentileBands }) => {
  const yieldRanges = [
    { range: '< 2.75', color: '#FF6B35', label: 'Very Low' },
    { range: '2.75 - 3.5', color: '#F7931E', label: 'Low' },
    { range: '3.5 - 4.25', color: '#FFD23F', label: 'Medium' },
    { range: '4.25 - 5.0', color: '#A8E6CF', label: 'Good' },
    { range: '5.0 - 5.25', color: '#90EE90', label: 'Very Good' },
    { range: '≥ 5.25', color: '#2E8B57', label: 'Excellent' }
  ];

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h4 className="text-sm font-semibold mb-3">Yield Legend (kWh/kWp)</h4>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 mb-4">
        {yieldRanges.map((range, index) => (
          <div key={index} className="flex items-center gap-2">
            <div 
              className="w-4 h-4 rounded border"
              style={{ backgroundColor: range.color }}
            />
            <div className="text-xs">
              <div className="font-medium">{range.range}</div>
              <div className="text-gray-500">{range.label}</div>
            </div>
          </div>
        ))}
      </div>

      {percentileBands.length > 0 && (
        <div className="border-t pt-3">
          <h5 className="text-xs font-semibold mb-2">Percentile Values</h5>
          <div className="flex flex-wrap gap-3">
            {percentileBands.map((band) => (
              <div 
                key={band.percentile}
                className={`text-xs px-2 py-1 rounded ${
                  band.is_target ? 'bg-blue-100 text-blue-800 font-semibold' : 'bg-gray-100'
                }`}
              >
                P{band.percentile}: {band.value}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};